<div class="image-preview ion-margin-bottom">
  <div *ngIf="isGenerating" class="overlay-generating">
    <ion-progress-bar type="indeterminate"></ion-progress-bar>
    <div class="overlay-generating-text">Generating card…</div>
  </div>
  <ion-img [src]="getSocialCardPreviewUrl()" *ngIf="getSocialCardPreviewUrl() && !isGenerating"
    (click)="focusTitleEditor()" style="cursor: pointer"></ion-img>
  <div class="placeholder" *ngIf="!getSocialCardPreviewUrl() && !isGenerating">
    <ion-icon name="image-outline"></ion-icon>
    <p>Image will be generated here</p>
  </div>
</div>

<div class="form-fields">
  <ion-item>
    <div *ngIf="!isEditingTitle" class="title-display-container" (click)="startEditingTitle()">
      <ion-label position="stacked">Title</ion-label>
      <p>{{ post.socialCard.title || 'Enter title or leave blank for AI' }}</p>
    </div>
    <div *ngIf="isEditingTitle" class="title-edit-container">
      <ion-textarea #titleInput label="Title" labelPlacement="floating" [(ngModel)]="editedTitle" [autoGrow]="true"
        placeholder="Enter title or leave blank for AI" spellcheck="true" autocorrect="on"></ion-textarea>
    </div>
  </ion-item>

  <ion-toolbar *ngIf="isEditingTitle">
    <ion-buttons slot="start">
      <ion-button color="secondary" (click)="generateTitleWithAI()">
        <ion-icon slot="start" name="refresh-circle-outline"></ion-icon>
        AI Redo
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button color="danger" (click)="cancelEditingTitle()">
        <ion-icon slot="end" name="close-circle-outline"></ion-icon>
        Cancel
      </ion-button>
      <ion-button color="success" (click)="saveTitle()">
        <ion-icon slot="start" name="checkmark-circle-outline"></ion-icon>
        Save
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-item *ngIf="shouldShowBlurb()">
    <ion-textarea label="Blurb" labelPlacement="floating" [(ngModel)]="post.socialCard.blurb"
      (ionBlur)="onModelChange()" [autoGrow]="true" placeholder="Enter blurb" spellcheck="true"
      autocorrect="on"></ion-textarea>
  </ion-item>

  <div class="last-item">
    <ion-item>
      <ion-select label="Image Placement" labelPlacement="floating" interface="popover"
        [(ngModel)]="post.socialCard.imagePlacement" (ionChange)="onModelChange()">
        <ion-select-option *ngFor="let item of imagePlacements" [value]="item.id">{{ item.label }}</ion-select-option>
      </ion-select>
    </ion-item>
  </div>

  <!--
  <ion-item>
    <ion-select label="Template" labelPlacement="floating" [(ngModel)]="post.socialCard.template"
      (ionChange)="onModelChange()">
      <ng-container *ngFor="let group of templateGroups">
        <ion-select-option *ngFor="let item of group.items" [value]="item.id">{{ item.label }}</ion-select-option>
      </ng-container>
    </ion-select>
  </ion-item>
  -->
</div>